/* eslint-disable max-len */
import classNames from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
// import { useRef, useState } from 'react'
// import { Else, If, Then, When } from 'react-if'
import Carousel from 'react-bootstrap/Carousel'
import CustomImage from 'src/components/Image'
// import useYoutubeVideo from 'src/hooks/business/use_youtube_video'
import getConfig from 'next/config'
import useI18n from 'src/hooks/use_i18n'
import { handleToShopify } from 'src/utils/tools'
import styles from './index.module.scss'

const { publicRuntimeConfig } = getConfig()

const assetPrefix = publicRuntimeConfig.assetPrefix || ''

export default function ShopifyIntro() {
  const { $t, activeLocale: locale } = useI18n()

  const getLocal = () => {
    const localMap = ['en', 'zh-cn', 'zh-hk']
    return localMap.includes(locale) ? locale : 'en'
  }

  // const [hasPlay, setHasPlay] = useState<boolean>(false)
  // const videoRef = useRef<HTMLVideoElement>(null)
  // const playerRef = useRef<HTMLDivElement>(null)

  // const handlePlayer = () => {
  //   videoRef.current?.play()
  //   setHasPlay(true)
  // }

  // useYoutubeVideo(locale)

  return (
    <section className={classNames('flex items-center', styles['shopify-intro'])}>
      <div className={styles['media-info']}>
        <Image
          src={assetPrefix + '/assets/images/track_page/shopify_app_store_logo.svg'}
          alt="17TRACK"
          className={styles['shopify-logo']}
          width={225}
          height={36}
        />
        <h1 className={classNames(styles.title)}>
          {$t('ResWwwPTrackCenterLP.global.__section1_orderTrackFreeEmailTitle')}
        </h1>
        <ul>
          <li className="flex">
            <CustomImage
              src={assetPrefix + '/assets/images/track_page/activation2x'}
              alt="17TRACK"
              width={15}
              height={13}
            />
            <p>{$t('ResWwwPShopify.global.__sellingPointsOne')}</p>
          </li>
          <li className="flex">
            <CustomImage
              src={assetPrefix + '/assets/images/track_page/activation2x'}
              alt="17TRACK"
              width={15}
              height={13}
            />
            <p>{$t('ResWwwPShopify.global.__sellingPointsTwo')}</p>
          </li>
        </ul>
        <div className={classNames('flex items-center', styles['btn-area'])}>
          <button className={classNames(styles.btn, styles['btn-green'])} onClick={handleToShopify}>
            <a href="https://apps.shopify.com/17track?utm_source=www.17track.net&utm_medium=track_page&utm_campaign=Get-started">
              {$t('ResWwwPTrackCenterLP.global.__section1_freeButton')}
            </a>
          </button>
          <button className={classNames(styles.btn, styles['btn-gray'])}>
            <Link
              className="cursor-pointer"
              href={`/${locale}/customers/shopify?utm_source=www.17track.net&utm_medium=default&utm_campaign=20230310customer-trackcenter-landing-page`}
              onClick={(e) => {
                e.preventDefault()
                window.ga?.sendEvent?.('主站客户品牌故事', '主页', '点击次数')
                location.href = `/${locale}/customers/shopify?utm_source=www.17track.net&utm_medium=default&utm_campaign=20230310customer-trackcenter-landing-page`
              }}
            >
              {$t('ResWwwPTrackCenterLP.global.__section1_contactButton')}
            </Link>
          </button>
        </div>
      </div>
      <div className={styles.carousel}>
        <Carousel prevIcon={<></>} nextIcon={<></>}>
          {Array(5)
            .fill(0)
            .map((_, index) => (
              <Carousel.Item>
                <CustomImage
                  src={`${assetPrefix}/assets/images/track_page/banner/${getLocal()}/${index}`}
                  alt="17TRACK"
                  width={745}
                  height={419}
                />
              </Carousel.Item>
            ))}
        </Carousel>
      </div>
      {/* <div className={styles['media-video']}>
        <If condition={!['zh-cn', 'zh-hk'].includes(locale)}>
          <Then>
            <div
              id="player"
              ref={playerRef}
              style={{ height: Number(playerRef.current?.offsetWidth) * (9 / 16) }}
            ></div>
          </Then>
          <Else>
            <video controls className={styles.video} ref={videoRef}>
              <source
                src="https://asset.17track.net/trackcenter/shopify/landingpage-cn.mp4?autostart=flase"
                type="video/mp4"
              ></source>
            </video>
          </Else>
        </If>

        <When condition={!hasPlay}>
          <div className={styles.poster} onClick={handlePlayer}>
            <svg width="80px" height="56px" viewBox="0 0 80 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="项目组件/播放器按钮Youtobe" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                  // eslint-disable-next-line max-len
                  d="M78.3303571 8.74777072C77.4035509 5.30043313 74.7094911 2.60640793 71.2589286 1.6764331 65.0178571 0 40 0 40 0 40 0 14.9821429 0 8.74107141 1.66751596 5.28879532 2.59453312 2.59348555 5.28980823 1.66964289 8.7388535 0 14.9808917 0 28 0 28 0 28 0 41.0191083 1.66964289 47.2522293 2.58928578 50.6942675 5.30357148 53.4050955 8.74107141 54.3235669 14.9821429 56 40 56 40 56 40 56 65.0178571 56 71.2589286 54.3235669 74.7053572 53.4050955 77.4107143 50.6942675 78.3303571 47.2522293 80 41.0191083 80 28 80 28 80 28 80 14.9808917 78.3303571 8.74777072Z"
                  fillOpacity="0.8"
                  fill="#000000"
                  fillRule="nonzero"
                ></path>
                <polygon
                  id="Path"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                  points="32.0535714 39.9490446 32.0535714 16.0509554 52.7678571 27.910828"
                ></polygon>
              </g>
            </svg>
          </div>
        </When>
      </div> */}
    </section>
  )
}
